import React from 'react';
import Scrollbars from 'react-custom-scrollbars';
import SplitPane from 'react-split-pane';
import { LFC } from '../../Legacy';
import { Fill } from '../../ui/Fill';
import { Page } from '../common/Page';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { XmasTree } from '../occasions/xmas/XmasTree';
import { Colors, remInPx } from './../../ui';
import { WorkspaceAboutPanel } from './WorkspaceAboutPanel';
import { WorkspaceMembersPanel } from './WorkspaceMembersPanel';

const XScrollbars = Scrollbars as any;
const XSplitPane = SplitPane as any;

const WithSidebar: LFC<{ top: React.ComponentType }> = ({ top, children }) =>
    <XSplitPane className="flex" split="vertical" primary="second" minSize={remInPx(10)} size={300} maxSize={remInPx(30)}>
        <WithoutSidebar top={top}>
            {children}
        </WithoutSidebar>
        <Page.Aside>
            <Fill flex="column">
                <Flexer flex="column" shrink>
                    <WorkspaceAboutPanel />
                </Flexer>
                <Flexer flex="column" grow>
                    <WorkspaceMembersPanel />
                </Flexer>
                <Flexer flex="column" shrink>
                    <XmasTree />
                </Flexer>
            </Fill>
        </Page.Aside>
    </XSplitPane>;

const WithoutSidebar: LFC<{ top: React.ComponentType }> = ({ top: Top, children }) =>
    <XScrollbars className="scrollbars" autoHide>
        <Flexer grow flex="column" style={{ background: Colors.hover, minHeight: '100%' }}>
            <Top />
            <Flexer grow flex="column">
                <Page.Content>
                    {children}
                </Page.Content>
            </Flexer>
        </Flexer>
    </XScrollbars>;

export const WorkspacePageContent: LFC<{ top: React.ComponentType, showSidebar?: boolean }> = ({ top, showSidebar, children }) => <>
    <Flexer relative grow zIndex="1">
        {!!showSidebar
            ? <WithSidebar top={top}>{children}</WithSidebar>
            : <WithoutSidebar top={top}>{children}</WithoutSidebar>
        }
    </Flexer>
</>;
